module.exports = __webpack_public_path__ + "img/DAVID_CANNON_09-rs.d8ac9818.jpg";